// 门禁预约-访客申请
<template>
  <div class="RKEAppointmentApply">
    <p class="experienceHint">当前为体验状态，正式使用请前往"我的"页面登录'</p>
    <div class="formBox">
      <p class="title">被访者信息</p>
      <ul class="form">
        <li class="li">
          <label class="left" for="vadr">访问地点</label>
          <div class="right">
            <input type="text" name="vadr" id="vadr" placeholder="请输入地点" v-model="address" disabled />
          </div>
        </li>
        <li class="li">
          <label class="left" for="uname">被访者姓名</label>
          <div class="right">
            <input type="text" name="uname" id="uname" placeholder="请输入姓名" v-model="params.uname" :disabled="$route.params.user_id" />
          </div>
        </li>
        <li class="li">
          <label class="left" for="vph">被访者电话</label>
          <div class="right">
            <!-- <input type="text" name="vph" id="vph" placeholder="请输入联系电话" v-model="params.vph" @input="vphInput" /> -->
            <input type="number" name="vph" id="vph" placeholder="请输入联系电话" v-model="params.vph" pattern="[0-9]*" @input="vphInput" :disabled="$route.params.user_id" />
          </div>
        </li>
        <li class="li">
          <label class="left" for="start_time">访问开始时间</label>
          <div class="right end" @click="showDatePicker('start')">
            <input type="text" placeholder="请选择访问开始时间" v-model="params.start_time" disabled />
            <span class="ico ico-right"></span>
          </div>
        </li>
        <li class="li">
          <label class="left" for="end_time">访问结束时间</label>
          <div class="right end" @click="showDatePicker('end')">
            <input type="text" placeholder="请选择访问结束时间" v-model="params.end_time" disabled />
            <span class="ico ico-right"></span>
          </div>
        </li>
      </ul>
    </div>
    <div class="formBox formBoxCover">
      <div class="cover" v-if="!isOYX" @click="formBoxCoverClick"></div>
      <p class="title">访客信息</p>
      <ul class="form vForm" v-for="(item, index) in params.visitor" :key="index">
        <div class="vNumber" v-show="params.visitor.length != 1">
          <p class="text">访客{{index+1}}</p>
          <span class="ico ico-round_close_fill_light" @click="deleteVisitor(index)"></span>
        </div>
        <li class="li m">
          <label class="left" for="vphoto">访客照片</label>
          <div class="right between"  @click="activeIndex = index" v-if="item.vphoto == ''">
            <input type="text" name="vphoto" id="vphoto" placeholder="请提交访客本人照片" disabled>
            <van-uploader :after-read="afterRead">
              <span class="ico ico-camera"></span>
            </van-uploader>
          </div>          
          <div class="right" v-else>
            <van-uploader :after-read="afterRead">
              <img class="vphoto" :src="item.vphoto" alt="访客照片">
            </van-uploader>
          </div>
        </li>
        <li class="li">
          <label class="left" for="vname">访客姓名</label>
          <div class="right">
            <input type="text" name="vname" id="vname" placeholder="请输入姓名" v-model="item.vname">
          </div>
        </li>
        <li class="li">
          <label class="left" for="vcard">证件号码</label>
          <div class="right">
            <input type="text" name="vcard" id="vcard" placeholder="请输入身份证号" v-model="item.vcard">
          </div>
        </li>
        <li class="li">
          <label class="left" for="vphone">访客电话</label>
          <div class="right">
            <!-- <input type="text" name="vphone" id="vphone" placeholder="请输入电话" v-model="item.vphone"> -->
            <input type="number" name="vphone" id="vphone" placeholder="请输入电话" pattern="[0-9]*" v-model="item.vphone" @input="vphoneInput" />
          </div>
        </li>
      </ul>
      <div class="btn-add" @click="addVisitor">
        <span class="ico ico-add1"></span>
        <span class="text">添加访客</span>
      </div>
    </div>

    <div class="bottom">
      <span class="btn" @click="reset">重置</span>
      <span class="btn" @click="submit">提交</span>
    </div>


    
      <!-- 时间选择 -->
      <van-popup class="date-popup" position="bottom" :close-on-click-overlay=false v-model="showDateSelect">
        <van-datetime-picker
          v-model="currentDate"
          type="datetime"
          :min-date="minDate"
          :formatter="formatter"
          @cancel="showDateSelect = false"
          @confirm="confirmDate" />
      </van-popup>
  </div>
</template>

<script>
  import { vconfirm, vshowSuccess, vNotify, vNotifyClose } from '../../../../static/js/phone/utility.js'
  import { getNowDate, showLoading, hideLoading } from "../../../../static/js/utility/utility.js"
  import * as wx from "../../../../static/js/phone/jweixin-1.3.2.js"

  import Vue from 'vue'
  import { DatetimePicker, Popup, Uploader } from 'vant'
  Vue.use(DatetimePicker)
  Vue.use(Popup)
  Vue.use(Uploader)

  let vm,
  vphoneReg = /^1[3|4|5|7|8|9][0-9]\d{8}$/,  // 手机号校验规则
  vcardReg = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/   // 身份证号校验规则

  export default {
    name: 'RKEAppointmentApplyE',
    data() {
      return {
        isMiniprogram: false, // 是否在小程序环境中

        address: '广东省广州市黄埔区神舟路19号',
        isOYX: true, // 被访者验证是否通过
        
        // 时间选择器
        showDateSelect: false,
        showDateSelectType: 'start',
        minDate: new Date(),
        currentDate: new Date(),

        activeIndex: 0,
        params: {
          uname: '',
          vph: '',
          start_time: getNowDate(new Date(), 'full'),
          end_time: getNowDate(new Date(new Date().getTime() + 1000 * 60 * 30), 'full'),
          visitor:[
            {
              vphoto:'',
              vname:'',
              vcard:'',
              vphone:''
            }
          ]
        }
      }
    },
    components: {
      DatetimePicker,
      Popup,
      Uploader
    },
    created() {
      console.log('tag', this.$route)
      vm = this
      vm.judgeIsMini()
      if (vm.$route.params.again == 'again') {
        vm.params =  {
          uname: '李四四',
          vph: '15771025141',
          start_time: getNowDate(new Date(), 'full'),
          end_time: getNowDate(new Date(new Date().getTime() + 1000 * 60 * 30), 'full'),
          visitor:[
            {
              vphoto:'../../../../static/images/avater.png',
              vname:'张三三',
              vcard:'360147198510101010',
              vphone:'13710212510'
            }
          ]
        }
      }
    },
    mounted() {
    //   let time =new Date(new Date().getTime() + 1000 * 60 * 30)
    // console.log( getNowDate(time, 'full'))
    },
    methods: {
      // 判断所处环境是否在小程序中
      judgeIsMini () {
        wx.miniProgram.getEnv(function(res) {
          vm.isMiniprogram  = res.miniprogram
        })
      },
      /* 监听被访者姓名输入 */
      unameBlur (e) {
        // console.log('tag', e.target.value != '' && vm.params.vph.length==11)
        if (e.target.value != '' && vm.params.vph.length==11){vm.getVisitor()}
      },
      /* 监听被访者手机号输入 */
      vphInput (e) {
        // console.log('e', e.target.value)
        // 限制只能输入数字
        e.target.value = e.target.value.replace(/[^0-9.]+/,'')
        if(e.target.value.length>11){ e.target.value=e.target.value.slice(0,11)}
        if (e.target.value.length==11 && vm.params.uname != ''){vNotifyClose();vm.getVisitor()}
      },
      vphBlur (e) {
        // if (e.target.value.length<11){vNotify('被访者电话格式不正确', 0)}
        console.log('vphoneReg.test(e.target.value)', vphoneReg.test(e.target.value))
        if (!vphoneReg.test(e.target.value)) {
          vNotify('被访者电话格式不正确', 0)
        }
        // console.log('vm.params', vm.params)
      },
      // 查询被访者信息是否正确
      async getVisitor () {
        vm.isOYX = true
        vNotifyClose()
      },
      // 显示时间选择器
      showDatePicker (type) {
        // console.log('', '')
        if (type == 'end' && vm.params.start_time == '') {
          vNotify('请先选择授权开始时间')
          return
        }
        vm.showDateSelect = true
        vm.showDateSelectType = type
        let date = type == 'start' ? new Date() : new Date(Date.parse(vm.params.start_time.replace(/-/g, "/")))
        vm.currentDate = date
        vm.minDate = date
        // console.log('vm.showDateSelectType', vm.showDateSelectType, vm.minDate)
      } ,
      // 确认时间
      confirmDate (value) {
        // console.log('value', getNowDate(value, 'full'))
        if (vm.showDateSelectType == 'start') {
          vm.params.start_time = getNowDate(value, 'full')
        }
        if (vm.showDateSelectType == 'end') {
          vm.params.end_time = getNowDate(value, 'full')
        }
        vm.showDateSelect = false
        // console.log('vm.showDateSelectType', vm.showDateSelectType)
        // console.log('时间', vm.params.start_time, vm.params.end_time)
      },
      formatter(type, value) {
        if (type === 'year') {
          return `${value}年`;
        } else if (type === 'month') {
          return `${value}月`
        } else if (type === 'day') {
          return `${value}日`
        } else if (type === 'hour') {
          return `${value}时`
        } else if (type === 'minute') {
          return `${value}分`
        }
        return value;
      },

      // 点击访客部分遮层
      formBoxCoverClick () {
        vNotify('请先验证通过被访者信息', 0)
      },
      // 访客手机号检验
      vphoneInput(e) {
        // 限制只能输入数字
        e.target.value = e.target.value.replace(/[^0-9.]+/,'')
        if(e.target.value.length>11){ e.target.value=e.target.value.slice(0,11)}
      },
      vphoneBlur (e) {
        if (!vphoneReg.test(e.target.value)) {
          vNotify('访客电话格式不正确', 0)
        } else {
          vNotifyClose()
        }
      },
      // 访客身份证号验证
      vcardBlur (e) {
        if (!vcardReg.test(e.target.value)) {
          vNotify('访客身份证号格式不正确', 0)
        } else {
          vNotifyClose()
        }
      },
      // 点击添加访客
      addVisitor () {
        vm.params.visitor.push({
          vphoto:'',
          vname:'',
          vcard:'',
          vphone:''
        })
      },
      // 点击删除访客
      deleteVisitor (index) {
        vm.params.visitor.splice(index, 1)
      },
      // 添加照片
      afterRead(file) {
        // 此时可以自行将文件上传至服务器
        console.log(file);
        vm.params.visitor[vm.activeIndex].vphoto = file.content
        console.log('activeIndex', vm.activeIndex)
      },
      // 重置
      reset () {
        vconfirm('重置将会清除所有信息，确认重置？').then(function () {
          vm.params = {
            uname: vm.$route.params.user_id ? vm.params.vname : '',
            vph: vm.$route.params.user_id ? vm.params.vph : '',
            start_time: getNowDate(new Date(), 'full'),
            end_time: getNowDate(new Date(new Date().getTime() + 1000 * 60 * 30), 'full'),
            visitor:[
              {
                vphoto:'',
                vname:'',
                vcard:'',
                vphone:''
              }
            ]
          }
        }).catch(function () {
          // console.log('已取消', '')
        })
      },
      // 提交预约信息
      submit () {
        // console.log('tag',getNowDate(new Date(), 'null'), new Date(getNowDate(new Date(), 'null')).getTime())
        // console.log('tag',vm.params.start_time,  new Date(vm.params.start_time).getTime())
        // return
        let data = vm.params
        data.aid = vm.$route.params.aid
        if (vm.$route.params.id) {data.edit_id = vm.$route.params.id}

        if (data.uname == '') {
          vNotify('被访者姓名不能为空')
          return
        }
        if (data.vph == '') {
          vNotify('被访者电话不能为空')
          return
        }
        if (data.start_time == '') {
          vNotify('访问开始时间不能为空')
          return
        } else {
          // if (new Date(data.start_time).getTime()- new Date(getNowDate(new Date(), 'null')).getTime() < 0) {
          //   vNotify('访问开始时间不能早于当前提交时间')
          //   return
          // }
        }
        if (data.end_time == '') {
          vNotify('访问结束时间不能为空')
          return
        }
        // 访客信息验证
        for(let i in data.visitor) {
          let item = data.visitor[i]
          if (item.vphoto == '') {
            vNotify('访客照片不能为空')
            return
          }
          if (item.vname == '') {
            vNotify('访客姓名不能为空')
            return
          }
          if (item.vcard == '') {
            vNotify('访客身份证号不能为空')
            return
          }
          if (item.vphone == '') {
            vNotify('访客手机号不能为空')
            return
          }
          // 默认第一个访客是发起人
          data.visitor[i].ini_status = i == 0 ? '1' : '0'
        }

        vconfirm('确认提交申请？').then(function () {
          vm.visitorInfo(data)
        }).catch(function () {
        })
      },
      // 提交访客信息
      async visitorInfo (data) {
        showLoading('提交中...')
        setTimeout(() => {
          hideLoading()
          vm.successOperation()
        }, 1000)
      },
      // 提交成功分场景操作（小程序端和网页端）
      successOperation () {
        console.log('vm.isMiniprogram', vm.isMiniprogram)
        if (vm.isMiniprogram) {
          // 若是小程序分享
          if (vm.$route.path.indexOf('appletShare') != -1) {
            vm.$router.push({path: '/PhonePage/AppointmentInform/Apply'})
          } else {
            vshowSuccess('提交成功')
            setTimeout(() => {
              wx.miniProgram.navigateBack({ delta: 1 })
            }, 1000)
          }
        } else {
          vm.$router.push({path: '/PhonePage/AppointmentInform/Apply'})
        }
      }
      
    },
    watch: {
    }
  };
</script>

<style lang="scss">

.experienceHint {
  width: 100%;
  height: 0.45rem;
  line-height: 0.45rem;
  font-size: 0.18rem;
  text-align: center;
  color: #ff0000;
  background-color: #feff71;
}
.van-notify {
  line-height: 0.56rem;
  padding: 0;
  font-size: 12px;
}
.RKEAppointmentApply {
  width: 100%;
  min-height: 100vh;
  background-color: #F0F2F2;
  padding-bottom: 0.92rem;
  .formBox {
    .title {
      height: 0.56rem;
      line-height: 0.56rem;
      font-size: 0.2rem;
      color: #888888;
      text-indent: 0.3rem;
    }
    .form {
      padding: 0 0.3rem;
      color: #1d1d26;
      background-color: #ffffff;
      .li {
        height: 0.7rem;
        font-size: 0.22rem;
        box-sizing: border-box;
        border-bottom: solid 1px #f3f3f3;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .left {
          width: 1.9rem;
          flex-shrink: 0;
        }
        .right {
          width: 3.8rem;
          display: flex;
          align-items: center;
          .ico {
            color: #2D83F4;
          }
          .ico.ico-right {
            margin-left: 0.3rem;
            font-size: 0.2rem;
          }
          .ico.ico-camera {
            font-size: 0.45rem;
          }
          input {
            width: 100%;
            height: 0.54rem;
            line-height: 0.54rem;
            background-color: #ffffff;
          }
          .vphoto {
            width: 0.7rem;
            height: 0.7rem;
            clip: rect(0px,0px,0px,0px);
          }
        }
        .right.end {
          justify-content: flex-end;
          input {
            text-align: right;
          }
        }
        .right.between {
          justify-content: space-between;
        }
      }
      .li.m {
        height: 1rem;
        padding: 0.15rem 0;
      }
    }
    .form.vForm {
      .vNumber {
        height: 0.7rem;
        font-size: 0.24rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .text {
          color: #ffb400;
        }
        .ico.ico-round_close_fill_light {
          color: #aaaaaa;
          font-size: 0.3rem;
        }
      }
      .li {
        border-bottom: none;
      }
      .li:last-child {
        border-bottom: solid 1px #f3f3f3;
      }
    }
    .btn-add {
      width: 100%;
      height: 0.7rem;
      line-height: 0.7rem;
      text-align: center;
      color: #2d83f4;
      font-size: 0.24rem;
      background-color: #ffffff;
      .ico {
        font-size: 0.24rem;
      }
    }
  }
  .formBox.formBoxCover {
    position: relative;
    .cover {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      z-index: 5;
    }
  }
  .placeholder {
    color: #ababab;
  }
  ::-webkit-input-placeholder{
    color: #ababab;
  }
  ::-moz-placeholder{
    color: #ababab;
  }
  :-ms-input-placeholder{
    color: #ababab;
  }
  .bottom {
    width: 100%;
    height: 0.7rem;
    text-align: center;
    font-size: 0.3rem;
    color: #ffffff;
    background-color: #2d83f4;
    display: flex;
    align-items: center;
    position: fixed;
    bottom: 0;
    left: 0;
    .btn {
      flex: 1;
      opacity: 0.6;
    }
  }
  .bottom:before {
    display: block;
    content: '';
    width: 1px;
    height: 0.6rem;
    background-color: #57bcee;
    position: absolute;
    left: 0 ;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/PhonePage/RKEAppointment/AppointmentApplyE.vue